import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"
import _imports_0 from '@/assets/teacher_index/version5/progress_pause.svg'


const _hoisted_1 = { class: "right-box flex-row align-center justify-end" }
const _hoisted_2 = ["src"]

import mqttServer from "@/js/mqtt"
import { onMounted, ref } from "vue"
import { useStorage } from "@vueuse/core"
import { getBrandImageUrl } from "@/js/brandImages"


export default /*@__PURE__*/_defineComponent({
  __name: 'speedSwitch',
  props: ["pauseFlag", "exerciseModal", "pauseShow"],
  emits: ["onPauseClass", "changeEnd"],
  setup(__props, { expose: __expose, emit: __emit }) {

const obj = {
  "1": getBrandImageUrl("speed/speed_1.svg"),
  "1.2": getBrandImageUrl("speed/speed_2.svg"),
  "1.5": getBrandImageUrl("speed/speed_3.svg"),
  "2": getBrandImageUrl("speed/speed_4.svg"),
}
const props = __props
const emit = __emit
const speedList = [1, 1.2, 1.5, 2]
const speed = useStorage("xf-speed", 1, localStorage)

const instructData = ref({
  project: "lxll",
  page: "teachIndex",
  module: "SpeedSwitch",
  userType: 1,
  data: null,
  fn: "",
  param: null,
  timestamp: " ",
})

onMounted(() => {
  mqttServer.onMqttMessage(instructData.value.module, onMessageReceived)
})

function onMessageReceived(msg: any) {
  console.log(msg, "11111111")
  if (msg.fn == "changeSpeed") {
    changeSpeedSync(msg.params[0])
  }
}

function changeSpeed(speed) {
  mqttServer
    .pushMsg(instructData.value, {
      params: [speed],
      fn: "changeSpeed",
      msgType: "function",
    })
    .then(() => {
      changeSpeedSync(speed)
    })
}

function changeSpeedSync(value?: any) {
  if (value) {
    console.log("value22", value)
    const index = speedList.indexOf(value)
    if (index !== 3 && index !== -1) {
      speed.value = speedList[index + 1]
    } else if (index === 3) {
      speed.value = speedList[0]
    }

    return
  }
  let currentIndex = speedList.indexOf(speed.value)
  currentIndex = ++currentIndex % speedList.length
  speed.value = speedList[currentIndex]
}

// 暴露方法
__expose({
  changeSpeedSync,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!props.pauseFlag && props.pauseShow)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "pause-icon cursor-pointer",
          src: _imports_0,
          alt: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onPauseClass')))
        }))
      : _createCommentVNode("", true),
    (!__props.exerciseModal)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: obj[_unref(speed)],
          alt: "",
          class: "speed-img",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeSpeed(_unref(speed))))
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})